import { Route, Switch as RRDSwitch, useRouteMatch } from 'react-router-dom';
import React from 'react';

import RoutesList from './features/RoutesList';
import NewRoute from './features/NewRoute';
import ExistingRoute from './features/ExistingRoute';

const Routes = () => {
  const { path } = useRouteMatch();

  return (
    <RRDSwitch>
      <Route exact path={path}>
        <RoutesList />
      </Route>
      <Route path={`${path}/new`}>
        <NewRoute />
      </Route>
      <Route
        path={`${path}/:id`}
        render={({
          match: {
            params: { id },
          },
        }) => <ExistingRoute id={id?.trim()} />}
      />
    </RRDSwitch>
  );
};

export default Routes;
